module.exports = "./static/disabled-bg.59e49bd9.png";